import React, { useContext } from "react";
import { GlobalContext } from "../../context/global.context";
import "./rag-banner.scss";

const RagBanner = ({ className = "" }) => {
  const { ragStatus, ragMessage } = useContext(GlobalContext);

  const imgMap = {
    red_retry: "RED",
    red_offline: "RED",
    red: "RED",
    yellow_loading: "YELLOW",
    yellow: "YELLOW",
    green: "GREEN",
    orange_nosource: "ORANGE_NOSOURCE",
  };
  const imgName = imgMap[ragStatus] ?? "YELLOW";

  return (
    <div className={`rag-banner ${className}`}>
      <img
        src={`/img/RAG_STATUS_${imgName}.png`}
        alt={`status: ${ragStatus}`}
        className="rag-banner__img"
      />
      <div className="rag-banner__text">
        <div className="rag-banner__ticker">
          <div
            className="rag-banner__ticker__track"
            style={{ animationDuration: `${Math.max(6, ragMessage.length * 0.18)}s` }}
          >
            <span>{ragMessage}</span>
            <span>{ragMessage}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RagBanner;
